module.exports = __webpack_public_path__ + "static/media/kredyt_7.c060a0c3.png";